"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
function checkIsOddActive(oddStatus, oddIsActive) {
    return oddStatus === types_1.GQL.OddStatus.NOT_RESULTED && !!oddIsActive;
}
exports.default = checkIsOddActive;
//# sourceMappingURL=checkIsOddActive.js.map